import apiClient from '@/api/client'
import type { ApiResponse } from '@/types/api'
import type { DashboardStats, CourseProgressData } from '../types'

export const dashboardApi = {
  fetchStats: () =>
    apiClient.get<ApiResponse<DashboardStats>>('/dashboard'),

  fetchCourseProgress: (courseId: string) =>
    apiClient.get<ApiResponse<CourseProgressData>>(
      `/dashboard/course-progress/${courseId}`,
      { params: { course_id: courseId } },
    ),
}
